module.exports = __webpack_public_path__ + "img/15_74.ff2bb9c5.png";